import React from "react";

export const IteamFormModal = ({ title = "", className = "", children }) => {
	return (
		<div className={`${className}`}>
			<div className="flex items-center gap-4 overflow-hidden h-[45px]">
				<div className="flex-grow">
					<h2 className="text-[12px] truncate">{title}</h2>
				</div>
				<div className="flex-grow-0 h-[1px] bg-[#CDCDCD] w-full"></div>
			</div>
			{children}
		</div>
	);
};
